<template>
    <div class="consumos">
        <div class="modal-list" :class="{'display': !isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Agregar pendiente manual</h3>
                </center>
                <span v-if="modelSelected" @click="modelSelected = !modelSelected"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="pending-info">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                        </div>
                        <button @click="addPendiente()">Agregar pendiente</button>
                    </div>
                    <div class="pending">
                        <div>
                            <h3>Seleccionar tipo de pendiente</h3>
                            <select name="" id="" v-model="pendingType">
                                <option v-for="(item, index) in pendingsTypes" :key="index" :value="item.name">{{ item.name }}</option>
                            </select>
                        </div>
                        <div>
                            <h3>Agregar la cantidad pendiente</h3>
                            <input type="number" name="" id="" v-model="pendingCharge">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="products_details" :title="'Detalles de venta'">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Detalles de la venta</h3>
                <div class="details">
                    <div class="ledgers">
                        <center>
                            <table>
                                <thead>
                                    <th>Producto</th>
                                    <th>categoria</th>
                                    <th>Cantidad</th>
                                    <th>Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in ledgers" :key="index">
                                        <td>{{item.producto}}</td>
                                        <td>{{item.categoria}}</td>
                                        <td>{{item.cantidad}}</td>
                                        <td>{{priceFormat(item.total)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </div>
                    <div class="info">
                        <label for="">Fecha: <span>{{created_at ? created_at.split($store.state.constants.SEPARETOR)[0] : null}}</span></label>
                        <label for="">Total: <span>{{priceFormat(total)}}</span></label>
                        <label for="">Cantidad productos: <span>{{cantidad}}</span></label>
                        <label for="">Vendedor: <span>{{seller}}</span></label>
                        <label for="">Comprador: <span>{{buyer}}</span></label>
                    </div>
                </div>
            </div>
        </b-modal>
        <div class="reportes">
            <div>
                <div class="tables">
                    <div class="consumos">
                        <div>
                            <h3>Consumos Tienda</h3>
                            <center>
                                <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="100">
                                    <thead>
                                        <th>Fecha</th>
                                        <th>Modelo</th>
                                        <th>Total</th>
                                        <th>Detalles</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in consumos" :key="index">
                                            <td>{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</td>
                                            <td>{{item.buyer}}</td>
                                            <td>{{priceFormat(item.total)}}</td>
                                            <td><button @click="details(item)">Ver detalles</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                    </div>
                    <div class="best">
                        <div>
                            <div class="first">
                                <h3>Productos mas vendidos</h3>
                                <center>
                                    <table>
                                        <thead>
                                            <th>Producto</th>
                                            <th>Cantidad</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in bestProducts" :key="index">
                                                <td>{{item.producto}}</td>
                                                <td>{{item.cantidad}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </center>
                            </div>
                            <div>
                                <h3>Mejores compradores</h3>
                                <center>
                                    <table>
                                        <thead>
                                            <th>Modelo</th>
                                            <th>Total</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in bestBuyers" :key="index">
                                                <td>{{item.buyer}}</td>
                                                <td>{{priceFormat(item.total)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="informe">
                    <div class="pendientes">
                        <div>
                            <button @click="isOpen = true">Agregar pendiente</button>
                            <h3>Pendientes por pagar</h3>
                            <center>
                                <table v-infinite-scroll="loadMorePending" infinite-scroll-disabled="busyPending" infinite-scroll-distance="100">
                                    <thead>
                                        <th>Modelo</th>
                                        <th>Total</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in pendings" :key="index">
                                            <td>{{item.to}}</td>
                                            <td>{{priceFormat(item.valor)}}</td>
                                            <td class="delete"><h4 @click="deletePending(item.id)">X</h4></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                    </div>
                    <div class="info">
                        <div>
                            <h3>Informe general</h3>
                            <div>
                                <div>
                                    <div>
                                        <h5>Total Consumos</h5>
                                        <h4>{{sumConsumos}}</h4>
                                    </div>
                                    <div>
                                        <h5>Cantidad consumos</h5>
                                        <h4>{{cantConsumos}}</h4>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <h5>Total consumos hoy</h5>
                                        <h4>{{sumConsumosHoy}}</h4>
                                    </div>
                                    <div>
                                        <h5>Cantidad consumos hoy</h5>
                                        <h4>{{cantConsumosHoy}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification'

export default {
    name: 'consumos',
    data() {
        return {
            consumos: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            ledgers: [],
            created_at: null,
            seller: null,
            buyer: null,
            datails: null,
            cantidad: null,
            total: null,
            bestBuyers: [],
            bestProducts: [],
            pendings: [],
            limitPending: 20,
            offsetPending: 0,
            busyPending: false,
            listEndPending: false,
            itemFlagPending: false,
            cantConsumos: null,
            sumConsumos: null,
            cantConsumosHoy: null,
            sumConsumosHoy: null,
            isOpen: false,
            modelSelected: null,
            searchValue: '',
            models: [],
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            pendingCharge: 0,
            pendingsTypes: [],
            pendingType: null
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.models = []
                this.getAllModels()
            }
        }
    },
    methods: {
        deletePending(id) {
            API.deletePending(id)
                .then(() => {
                    this.pendings = []
                    this.limitPending = 20
                    this.offsetPending = 0
                    this.pendings = []
                    this.getPendings()
                })
        },
        getPendingTypes() {
            API.getPendingTypes()
                .then((res) => {
                    this.pendingsTypes = res
                })
        },
        addPendiente() {
            this.pendings = []
            this.limitPending = 20
            this.offsetPending = 0
            API.createPendingCharge(this.userIdSelect, this.pendingCharge, this.pendingType)
                .then((res) => {
                    this.searchValue = ''
                    this.getPendings()
                    this.isOpen = false
                    this.userIdSelect = null
                    this.modelSelected = null
                    this.userImgselect = null
                    this.userNameSelect = null
                    this.userTypeSelect = null
                })
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            }
        },
        onEnter () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getAllModelsSearch(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.models.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getAllModels()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        logOut() {
            this.$store.commit('logOut')
            this.$router.push('/login')
        },
        changeCantidad(id, cantidad) {
            API.Store.changeCantidadProducto(id, cantidad)
                .then(() => {
                    clearInterval(this.intervalid)
                    this.getOpenVentas()
                    Notify('dirty', 'Se ha cambiado la cantidad del producto con exito')
                })
        },
        details(venta) {
            this.ledgers = venta.ledgers
            this.created_at = venta.created_at
            this.seller = venta.seller
            this.buyer = venta.buyer
            this.cantidad = venta.cantidad
            this.total = venta.total
            this.$refs.products_details.show()
        },
        getConsumos() {
            API.getConsumos(this.limit, this.offset)
                .then((res) => {
                    res.map(consumo => { this.consumos.push(consumo) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.consumos.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getConsumos()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        loadMorePending() {
            this.busyPending = true
            if (!this.listEndPending) {
                setTimeout(() => {
                    if (this.pendings.length < this.offset) {
                        this.listEndPending = true
                        return
                    }
                    if (this.itemFlagPending) {
                        this.getPendings()
                        this.busyPending = false
                    } else {
                        this.loadMorePending()
                    }
                }, 1000)
            }
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getBestBuyer() {
            API.getBestBuyer()
                .then((res) => {
                    this.bestBuyers = res
                })
        },
        getBestProducts() {
            API.getBestProducts()
                .then((res) => {
                    this.bestProducts = res
                })
        },
        getPendings() {
            API.getPendings(this.limitPending, this.offsetPending)
                .then((res) => {
                    res.map(pendiente => { this.pendings.push(pendiente) })
                    this.offsetPending += this.limitPending
                    this.itemFlagPending = true
                })
        },
        getCantConsumos() {
            API.getCantConsumos()
                .then((res) => {
                    this.cantConsumos = res.cantidad
                })
        },
        getSumConsumos() {
            API.getSumConsumos()
                .then((res) => {
                    this.sumConsumos = Price(res.total)
                })
        },
        getCantConsumosHoy() {
            API.getCantConsumosHoy()
                .then((res) => {
                    this.cantConsumosHoy = res.cantidad
                })
        },
        getSumConsumosHoy() {
            API.getSumConsumosHoy()
                .then((res) => {
                    this.sumConsumosHoy = Price(res.total)
                })
        }
    },
    mounted() {
        this.getConsumos()
        this.getBestBuyer()
        this.getBestProducts()
        this.getPendings()
        this.getCantConsumos()
        this.getSumConsumos()
        this.getCantConsumosHoy()
        this.getSumConsumosHoy()
        this.getAllModels()
        this.getPendingTypes()
    }
}
</script>

<style scoped>
    .consumos {
        background-color: #cdcdcd;
        height: 90vh;
        position: relative;
    }
    .consumos > div.modal-list {
        padding: 40px;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99;
        border-radius: 0px;
    }
    .consumos > div.modal-list > div{
        background-color: #FFF;
        height: 90%;
        width: 90%;
        padding: 20px;
        color: #000;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .consumos > .display{
        display: none;
    }
    .consumos > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .consumos > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .consumos > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .consumos > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .consumos > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .consumos > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .consumos > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 50%;
        height: 50%;
        object-fit: cover;
    }
    .consumos > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .consumos > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .consumos > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .consumos > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .consumos > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .consumos > div.modal-list > div > div.pending-info {
        width: 100%;
        height: 90%;
        display: flex;
    }
    .consumos > div.modal-list > div > div.pending-info > div.model-info {
        width: 30%;
        height: 90%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .consumos > div.modal-list > div > div.pending-info > div.model-info > button{
        position: absolute;
        bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .consumos > div.modal-list > div > div.pending-info > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .consumos > div.modal-list > div > div.pending-info > div.model-info > div {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .consumos > div.modal-list > div > div.pending-info > div.pending {
        width: 100%;
        height: 100%;
        padding: 30px;
        position: relative;
    }
    .consumos > div.modal-list > div > div.pending-info > div.pending > div {
        text-align: center;
        padding: 50px;
    }
    .consumos > div.modal-list > div > div.pending-info > div.pending > div > select {
        height: 40px;
        width: 300px;
        border-radius: 20px;
        text-align: center;
    }
    .consumos > div.modal-list > div > div.pending-info > div.pending > div > h3 {
        margin: 20px;
        margin-bottom: 70px;
    }
    .consumos > div.modal-list > div > div.pending-info > div.pending > div > input {
        height: 40px;
        width: 300px;
        border-radius: 20px;
        text-align: center;
    }
    .consumos > .reportes {
        padding: 10px;
        width: 100%;
        height: 100%;
    }
    .consumos > .reportes > div {
        width: 100%;
        height: 100%;
        display: flex;
    }
    .consumos > .reportes > div > div.tables {
        padding: 10px;
        width: 60%;
        height: 100%;
        padding: 0px;
    }
    .consumos > .reportes > div > div.informe {
        padding: 10px;
        width: 40%;
        height: 100%;
        padding: 0px;
    }
    .consumos > .reportes > div > div > div.consumos{
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .consumos > .reportes > div > div > div.pendientes{
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .consumos > .reportes > div > div > div.pendientes > div > center > table > tbody > tr > td.delete {
        width: 3%;
    }
    .consumos > .reportes > div > div > div.pendientes > div > center > table > tbody > tr > td.delete > h4:hover {
        color: red;
        cursor: pointer;
    }
    .consumos > .reportes > div > div > div.best{
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .consumos > .reportes > div > div > div.info{
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .consumos > .reportes > div > div > div.consumos > div{
        background-color: #63b1b7;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        text-align: center;
        color: #fff;
        padding: 20px;
        overflow-y: auto;
    }
    .consumos > .reportes > div > div > div.consumos > div > center > table > thead > th {
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
        font-weight: bold;
        background-color: #585858;
    }
    .consumos > .reportes > div > div > div.consumos > div > center > table > tbody > tr > td {
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
    }
    .consumos > .reportes > div > div > div.consumos > div > center > table > tbody > tr > td > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100px;
        height: 30px;
        border-radius: 30px;
    }
    .consumos > .reportes > div > div > div.pendientes > div{
        background-color: #8363b7;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        color: #fff;
        padding: 20px;
        overflow-y: auto;
        position: relative;
    }
    .consumos > .reportes > div > div > div.pendientes > div > button {
        position: absolute;
        right: 10px;
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 200px;
        height: auto;
        border-radius: 30px;
    }
    .consumos > .reportes > div > div > div.pendientes > div > center > table > thead > th{
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
        font-weight: bold;
        background-color: #63b1b7;
    }
    .consumos > .reportes > div > div > div.pendientes > div > center > table > tbody > tr > td{
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
    }
    .consumos > .reportes > div > div > div.best > div{
        background-color: #585858;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        display: flex;
    }
    .consumos > .reportes > div > div > div.best > div > div{
        width: 50%;
        text-align: center;
        color: #fff;
        padding: 20px;
    }
    .consumos > .reportes > div > div > div.best > div > div > center > table > thead > th{
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
        font-weight: bold;
        background-color: #63b78c;
    }
    .consumos > .reportes > div > div > div.best > div > div > center > table > tbody > tr > td{
        border-style: outset;
        padding: 10px;
        width: 10%;
        text-align: center;
    }
    .consumos > .reportes > div > div > div.best > div > div.first{
        border-right-style: double;
    }
    .consumos > .reportes > div > div > div.info > div{
        background-color: #63b78c;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        text-align: center;
        color: #fff;
        padding: 20px;
    }
    .consumos > .reportes > div > div > div.info > div > div{
        margin-top: 20px;
        width: 100%;
        height: 80%;
    }
    .consumos > .reportes > div > div > div.info > div > div > div{
        display: flex;
        height: 50%;
    }
    .consumos > .reportes > div > div > div.info > div > div > div > div{
        width: 50%;
        text-align: center;
    }
    .consumos > .reportes > div > div > div.info > div > div > div > div > h4{
        color: #000;
        font-weight: bolder;
    }
    .info-wrapper > h3 {
        margin-bottom: 40px;
    }
    .info-wrapper{
        padding: 50px;
    }
    .info-wrapper > .details {
        display: flex;
    }
    .info-wrapper > .details {
        display: flex;
    }
    .info-wrapper > .details > div{
        width: 50%;
    }
    .info-wrapper > .details > .ledgers > center > table > thead > th{
        border-style: outset;
        text-align: center;
        width: 150px;
    }
    .info-wrapper > .details > .ledgers > center > table > tbody > tr > td{
        border-style: outset;
        text-align: center;
        width: 150px;
    }
    .info-wrapper > .details > .info{
        padding-left: 30px;
        display: grid;
    }
    .info-wrapper > .details > .info > label{
        font-size: 24px;
    }
    .info-wrapper > .details > .info > label > span{
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Consumos.vue